import { render, staticRenderFns } from "./FButtonGroup.vue?vue&type=template&id=16accb9b&scoped=true&"
import script from "./FButtonGroup.vue?vue&type=script&lang=js&"
export * from "./FButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./FButtonGroup.vue?vue&type=style&index=0&id=16accb9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16accb9b",
  null
  
)

export default component.exports